module.exports = __webpack_public_path__ + "img/WOO.0da43e1b.png";